import { RangeWithY } from './ranges'
import { DeviceVisibility, RunnerPartialObject } from './RunnerPartialObject'

export interface Node {
  name: string
  objectId: string
  type: string
  originalY: number
  originalHeight: number
  yOffset: number
  heightOffset: number
  range: RangeWithY
  pushedBy: Node[]
  pushes: Node[]
  children: Node[]
  itemId?: number
  items?: number[]
  template?: RunnerPartialObject[]
  parent?: Node
  deviceVisibility?: DeviceVisibility
}
